export const SupportIconV2 = ({ width = "60" }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 67 66"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      {/* background circle */}
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" fill="white" />
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" stroke="#916CF1" />

      {/* centered + scaled path */}
      <g
        transform="translate(14, 10) scale(1.6)"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z" />
      </g>
    </svg>
  );
};
